import axios from 'axios/index'

const namespaced = true

const state = {
  companies: null,
  FCSData: null,
  CTMData: null,
  FNSData: null,
  fnsContentUrl: ''
}
const actions = {
  companiesList ({ commit }) {
    return axios.get('/api/private/v3.0/companies/')
      .then(response => {
        commit('setCompanies', response.data)
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getInfodecData ({ commit }, data) {
    return axios({
      method: 'POST',
      url: '/api/private/v3.0/infodec/organizations/logins/',
      data: {
        inn: data.inn,
        kpp: data.kpp
      }
    })
      .then(response => {
        console.log(response)
        commit('getFCSData', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getFNSData ({ commit }, data) {
    return axios({
      method: 'GET',
      url: '/api/private/v3.0/nalog/egrul/' + data.inn + '/'
    })
      .then(response => {
        console.log(response)
        commit('getFNSData', { response: response.data, row_data: data })
      })
      .catch(error => {
        console.log(error)
      })
  },
  sendCRMData () {
    return axios.post('/api/private/v3.0/ctm/crm/order/')
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getClientProgram ({ commit }, data) {
    console.log(data)
    return axios({
      method: 'POST',
      url: '/api/private/v3.0/ctm/organizations/search/',
      data: {
        inn: data.inn,
        kpp: data.kpp,
        dealer_id: 77
      }
    })
      .then(response => {
        console.log(response)
        commit('getCTMData', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  }
}
const mutations = {
  setCompanies (state, data) {
    state.companies = data
  },
  getFCSData (state, data) {
    state.FCSData = data
    console.log(data)
  },
  getCTMData (state, data) {
    state.CTMData = data
    console.log(data)
  },
  getFNSData (state, data) {
    console.log(data)
    state.FNSData = data.response
    state.fnsContentUrl = '/api/private/v3.0/nalog/egrul/' + data.row_data.inn + '/document/' + data.response.document.id + '/content/'
    console.log(data)
  }
}
const getters = {}

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}
